/** Claves de módulo alineadas con backend `rbac_catalog` (demo). */

export const RBAC_MODULE_IDS = [
  'dashboard',
  'employee_portal',
  'employees',
  'lifecycle',
  'org_chart',
  'legajo',
  'payslips',
  'attendance',
  'leaves',
  'expenses',
  'personal_finance',
  'communications',
  'rrhh_emails',
  'evaluations',
  'training',
  'surveys',
  'awards',
  'people_intelligence',
  'notifications',
  'reports',
  'settings',
  'flow_ia',
  'feed',
  'chat',
];

export const RBAC_ACTION_KEYS = ['view', 'create', 'edit', 'approve', 'reject', 'delete', 'export', 'admin'];

export const MOCK_ROLE_STORAGE_KEY = 'spectra_rrhh_mock_role';

export const DEFAULT_MOCK_ROLE = 'rrhh_admin';

/** @param {Record<string, any> | null | undefined} snapshot */
export function canWith(snapshot, module, action, productionStrict = false) {
  if (!snapshot || !snapshot.permissions) {
    return productionStrict ? false : true;
  }
  const row = snapshot.permissions[module];
  if (!row) return productionStrict ? false : true;
  return !!row[action];
}

export function permissionLabelKey(action) {
  return `permissions.action_${action}`;
}

export function moduleLabelKey(moduleId) {
  return `permissions.module_${moduleId}`;
}

export function roleTitleKey(roleId) {
  return `permissions.roleTitle_${roleId}`;
}

export function roleDescKey(roleId) {
  return `permissions.roleDesc_${roleId}`;
}
